<input pInputText
  id="number"
  #text="ngModel"
  type="number"
  [required]="column.validation?.isRequired === true"
  [maxlength]="column.validation?.maxLength || null"
  [(ngModel)]="record[column.field]" />

  @if (text.invalid && (text.dirty || text.touched)) {
    <div
      class="alert">
      @if (text.errors?.['required']) {
        <div>
          Required.
        </div>
      }
    </div>
  }
